import React, { useEffect, useRef } from 'react'

interface ChatContextMenuProps {
  x: number
  y: number
  isVisible: boolean
  isPinned: boolean
  isMuted: boolean
  onClose: () => void
  onPin: () => void
  onUnpin: () => void
  onMute: () => void
  onUnmute: () => void
}

const ChatContextMenu: React.FC<ChatContextMenuProps> = ({
  x,
  y,
  isVisible,
  isPinned,
  isMuted,
  onClose,
  onPin,
  onUnpin,
  onMute,
  onUnmute,
}) => {
  const menuRef = useRef<HTMLDivElement>(null)

  // 点击外部关闭菜单
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        onClose()
      }
    }

    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose()
      }
    }

    if (isVisible) {
      document.addEventListener('mousedown', handleClickOutside)
      document.addEventListener('keydown', handleEscape)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
      document.removeEventListener('keydown', handleEscape)
    }
  }, [isVisible, onClose])

  // 菜单项点击处理
  const handleMenuItemClick = (action: () => void) => {
    action()
    onClose()
  }

  if (!isVisible) return null

  // 调整菜单位置，防止超出屏幕
  const adjustedX = Math.min(x, window.innerWidth - 200)
  const adjustedY = Math.min(y, window.innerHeight - 120)

  return (
    <div
      ref={menuRef}
      className="fixed z-50 bg-white rounded-lg shadow-lg border border-gray-200 py-2 min-w-36"
      style={{
        left: adjustedX,
        top: adjustedY,
      }}
    >
      {/* 置顶/取消置顶 */}
      <button
        onClick={() => handleMenuItemClick(isPinned ? onUnpin : onPin)}
        className="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-50 flex items-center space-x-2"
      >
        <svg 
          className="w-4 h-4" 
          fill="currentColor" 
          viewBox="0 0 20 20"
        >
          {isPinned ? (
            // 取消置顶图标
            <path fillRule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clipRule="evenodd" />
          ) : (
            // 置顶图标 
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
          )}
        </svg>
        <span>{isPinned ? '取消置顶' : '置顶对话'}</span>
      </button>

      {/* 静音/取消静音 */}
      {/* <button
        onClick={() => handleMenuItemClick(isMuted ? onUnmute : onMute)}
        className="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-50 flex items-center space-x-2"
      >
        <svg 
          className="w-4 h-4" 
          fill="currentColor" 
          viewBox="0 0 20 20"
        >
          {isMuted ? (
            // 取消静音图标
            <path fillRule="evenodd" d="M9.383 3.076A1 1 0 0110 4v12a1 1 0 01-1.617.788L4.828 13H2a1 1 0 01-1-1V8a1 1 0 011-1h2.828l3.555-3.788zm6.125.196a1 1 0 011.414 0 7.967 7.967 0 010 11.256 1 1 0 11-1.414-1.414 5.967 5.967 0 000-8.428 1 1 0 010-1.414z" clipRule="evenodd" />
          ) : (
            // 静音图标
            <path fillRule="evenodd" d="M9.383 3.076A1 1 0 0110 4v12a1 1 0 01-1.617.788L4.828 13H2a1 1 0 01-1-1V8a1 1 0 011-1h2.828l3.555-3.788zM13 8.414l1.415-1.415a1 1 0 011.414 1.414L14.414 10l1.415 1.415a1 1 0 11-1.414 1.414L13 11.414l-1.415 1.415a1 1 0 11-1.414-1.414L11.586 10 10.17 8.585a1 1 0 011.414-1.414L13 8.414z" clipRule="evenodd" />
          )}
        </svg>
        <span>{isMuted ? '取消静音' : '静音对话'}</span>
      </button> */}
    </div>
  )
}

export default ChatContextMenu
